<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-user"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="user"
                      placeholder="Username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      v-model="passw"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        class="px-4"
                        @click="getToken"
                        v-on:keyup.13="getToken"
                        >Login</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                        >Forgot password?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width:44%"
              v-if="showSignUp"
            >
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </p>
                  <b-button variant="primary" class="active mt-3"
                    >Register Now!</b-button
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      user: "",
      passw: "",
      showSignUp: false
    };
  },
  methods: {
    getToken() {
      console.log("-- getToken");
      var vm = this;
      axios.defaults.headers.common = {
        "Content-Type": "application/x-www-form-urlencoded"
      };
      // axios.defaults.headers.common = {
      //   "X-Requested-With": "XMLHttpRequest",
      //   Accept: "text/plain"
      // };
      // "Content-Type": "application/x-www-form-urlencoded"
      axios
        .post(this.$store.state.baseUrl + "oauth/token", {
          username: vm.user,
          password: vm.passw,
          grant_type: "password",
          client_id: this.$store.state.client_id,
          client_secret: this.$store.state.client_secret
        })
        .then(function(response) {
          // handle success
          localStorage.setItem("token", response.data.access_token);
          //vm.$store.commit('setAdmin');
          // console.log(response.data.access_token);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
          vm.$router.push("/");
          //console.log(localStorage.getItem('token'));
        });
    },
    testToken() {
      console.log("--- testToken");

      const bearer = "Bearer " + localStorage.getItem("token");
      axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: bearer
      };
      // Make a request for a user with a given ID
      axios
        .get(this.$store.state.baseUrl + "api/info")
        .then(function(response) {
          // handle success
          console.log(response);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    }
  },
  created() {
    console.log("--- login created");
    let token = localStorage.getItem("token");
    if (token) {
      this.$router.push("/");
    }
  }
}; //
</script>
